import { useContext, useEffect } from "react";
import { AuthContext } from "../Auth/Context";
import { Navigate, useLocation } from "react-router-dom";
import { usePermissions } from "../hooks/usePermissions";

export const PrivateRoute = ({
  allowedClasses = [],
  allowedTypes = [],
  action,
  resource,
  scope,
  children,
}) => {
  const { logged, payload } = useContext(AuthContext);
  const { pathname } = useLocation();

  const { can } = usePermissions(payload);

  const classUser = payload?.profile?.class || "";
  const typeUser = payload?.profile?.typeAgent || "";

  // ✅ Validación por rol (como ya lo tenías)
  const hasRoleAccess =
    allowedClasses.length === 0 || allowedClasses.includes(classUser);

  // ✅ Validación por tipo de usuario
  const hasTypeAccess =
    !allowedTypes || allowedTypes.includes(typeUser);

  // ✅ Validación por permisos (nuevo)
  const hasPermissionAccess =
    !action || !resource || can(action, resource, scope);

  // ✅ Acceso final
  const hasAccess = logged && hasRoleAccess && hasTypeAccess && hasPermissionAccess;

  useEffect(() => {
    if (hasAccess) {
      sessionStorage.setItem("lastPath", pathname);
    }
  }, [hasAccess, pathname]);

  return hasAccess ? children : <Navigate to="/" />;
};